import React, { useContext } from 'react';
import { useDeviationViewContext } from '../../../Context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType, isLegacyStatus, } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import DesktopActionBar from '../../variants/DesktopActionBar';
import MobileActionBar from '../../variants/MobileActionBar';
import ExpandActionBar from '../../variants/ExpandActionBar';
import SimpleActionBar from '../../variants/SimpleActionBar';
import CommissionActionBar from '../../variants/CommissionActionBar';
import TierActionBar from '../../variants/TierActionBar';
var ActionBarContent = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var isMobile = useContext(MobileContext);
    var deviationType = getDeviationType(deviation);
    if (isFullscreen) {
        return React.createElement(ExpandActionBar, { deviation: deviation, isOwner: isOwner });
    }
    if (isMobile) {
        return React.createElement(MobileActionBar, { deviation: deviation, isOwner: isOwner });
    }
    if (deviationType === DeviationTypes.STATUS && !isLegacyStatus(deviation)) {
        return React.createElement(DesktopActionBar, { deviation: deviation, isOwner: isOwner });
    }
    switch (deviationType) {
        case DeviationTypes.STATUS:
        case DeviationTypes.POLL:
            return React.createElement(SimpleActionBar, { deviation: deviation, isOwner: isOwner });
        case DeviationTypes.COMMISSION:
            return React.createElement(CommissionActionBar, { deviation: deviation, isOwner: isOwner });
        case DeviationTypes.TIER:
            return React.createElement(TierActionBar, { deviation: deviation, isOwner: isOwner });
        default:
            return React.createElement(DesktopActionBar, { deviation: deviation, isOwner: isOwner });
    }
};
ActionBarContent.displayName = 'ActionBarContent';
export default ActionBarContent;
//# sourceMappingURL=ActionBarContent.js.map